
function init() {
  initSection1Slides()
  initSection2Slides()
  initSection2aSlides()
  initScrollReveals()
}



function initScrollReveals() {
  var logo = document.querySelector('header .logo')
}


function initSection1Slides() {
  var slides = Array.from(document.querySelectorAll('section.s1 .slide'))
  if(!slides.length) return;
  var dotsContainer = document.querySelector('section.s1 .dots')
  var dots = Array.from(document.querySelectorAll('section.s1 .dot'))
  var currentSlide = null
  var currentDot = null
  var timer = setInterval(nextSlide, 5000)
  dots.forEach((dot, i) => dot.onclick = () => onDotClicked(i))
  function setSlide(index) {
    currentSlide?.classList.remove('active')
    currentDot?.classList.remove('active')
    currentSlide = slides[index]
    currentDot = dots[index]
    currentSlide?.classList.add('active')
    currentDot?.classList.add('active')
  }
  function nextSlide() {
    const currentIndex = slides.indexOf(currentSlide) || 0
    let nextIndex = currentIndex + 1
    if(nextIndex > slides.length - 1) nextIndex = 0
    setSlide(nextIndex)
  }
  function onDotClicked(index) {
    clearInterval(timer)
    setSlide(index)
  }
  setSlide(0)
  slides.length < 2 && dotsContainer.classList.add(`hidden`)
}


function initSection2Slides() {

  var timer = null

  function createSlides() {
    clearInterval(timer)
    var currentSlide = null
    var currentDot = null
    var threshold = 768
    var isMobile = window.innerWidth < threshold
    var container = document.querySelector('section.s2 .slides')
    if(!container) return
    var dotsContainer = document.querySelector('section.s2 .dots')
    var collections = Array.from(document.querySelectorAll('section.s2 .collection'))
    var totalSlides = isMobile ? collections.length : Math.ceil(collections.length / 2)
    container.innerHTML = ''
    dotsContainer.innerHTML = ''
    var i = 0
    var dots = []
    var slides = Array(totalSlides).fill().map((n, index) => {
      var slide = document.createElement('div')
      slide.className = 'slide'
      container.appendChild(slide)
      if(isMobile) {
        slide.appendChild(collections[i])
        i = i + 1
      } else {
        slide.appendChild(collections[i])
        collections[i + 1] && slide.appendChild(collections[i + 1])
        i = i + 2
      }
      var dot = document.createElement('div')
      dot.className = 'dot'
      dotsContainer.appendChild(dot)
      dot.onclick = () => onDotClicked(index)
      dots.push(dot)
      return slide
    })
    function nextSlide() {
      const currentIndex = slides.indexOf(currentSlide) || 0
      let nextIndex = currentIndex + 1
      if(nextIndex > slides.length - 1) nextIndex = 0
      setSlide(nextIndex)
    }
    function onDotClicked(index) {
      clearInterval(timer)
      setSlide(index)
    }
    function setSlide(index) {
      if(index < 0 || index > slides.length - 1) return
      currentSlide?.classList.remove('active')
      currentDot?.classList.remove('active')
      currentSlide = slides[index]
      currentDot = dots[index]
      currentSlide.classList.add('active')
      currentDot.classList.add('active')
      var slideWidth = currentSlide.offsetWidth
      var offsetX = slideWidth * index * -1
      container.style.setProperty('--offsetX', `${offsetX}px`);
    }
    setSlide(0)
    timer = setInterval(nextSlide, 5000)
    slides.length < 2 && dotsContainer.classList.add(`hidden`)
  }

  window.addEventListener('resize', createSlides)
  createSlides()
}

function initSection2aSlides() {

  var timer = null

  function createSlides() {
    clearInterval(timer)
    var currentSlide = null
    var currentDot = null
    var threshold = 768
    var isMobile = window.innerWidth < threshold
    var container = document.querySelector('section.s2a .slides')
    if(!container) return
    var dotsContainer = document.querySelector('section.s2a .dots')
    var collections = Array.from(document.querySelectorAll('section.s2a .collection'))
    var totalSlides = isMobile ? collections.length : Math.ceil(collections.length / 2)
    container.innerHTML = ''
    dotsContainer.innerHTML = ''
    var i = 0
    var dots = []
    var slides = Array(totalSlides).fill().map((n, index) => {
      var slide = document.createElement('div')
      slide.className = 'slide'
      container.appendChild(slide)
      if(isMobile) {
        slide.appendChild(collections[i])
        i = i + 1
      } else {
        slide.appendChild(collections[i])
        collections[i + 1] && slide.appendChild(collections[i + 1])
        i = i + 2
      }
      var dot = document.createElement('div')
      dot.className = 'dot'
      dotsContainer.appendChild(dot)
      dot.onclick = () => onDotClicked(index)
      dots.push(dot)
      return slide
    })
    function nextSlide() {
      const currentIndex = slides.indexOf(currentSlide) || 0
      let nextIndex = currentIndex + 1
      if(nextIndex > slides.length - 1) nextIndex = 0
      setSlide(nextIndex)
    }
    function onDotClicked(index) {
      clearInterval(timer)
      setSlide(index)
    }
    function setSlide(index) {
      if(index < 0 || index > slides.length - 1) return
      currentSlide?.classList.remove('active')
      currentDot?.classList.remove('active')
      currentSlide = slides[index]
      currentDot = dots[index]
      currentSlide.classList.add('active')
      currentDot.classList.add('active')
      var slideWidth = currentSlide.offsetWidth
      var offsetX = slideWidth * index * -1
      container.style.setProperty('--offsetX', `${offsetX}px`);
    }
    setSlide(0)
    timer = setInterval(nextSlide, 5000)
    slides.length < 2 && dotsContainer.classList.add(`hidden`)
  }

  window.addEventListener('resize', createSlides)
  createSlides()
}

init()

// (function(){
//   window.addEventListener('resize', onResize)
//   onResize()

//   function onResize() {
//     var width = 572
//     var height = 860
//     var ratio = height / width
//     var designers = Array.from(document.querySelectorAll('.designer'))
//     designers.forEach(designer => {
//       var hero = designer.querySelector('.hero')
//       hero.style.height = `${hero.offsetWidth * ratio}px`
//       designer.classList.add('ready')
//     })
//   }
// })()
